import styled from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

export const StyledLogoImg = styled.img<IWithSize>`
  width: ${({ size }) => (size ? 110 * size : 110)}px;
  height: ${({ size }) => (size ? 21 * size : 21)}px;
  margin-right: ${({ size }) => (size ? 15 * size : 15)}px;
`
